module.exports = __webpack_public_path__ + "2a28d96b55140e4938ba29129e6ef32d.js";